import { render, staticRenderFns } from "./kafkaConfigTable.vue?vue&type=template&id=6f3d8bd6&scoped=true&"
import script from "./kafkaConfigTable.vue?vue&type=script&lang=js&"
export * from "./kafkaConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./kafkaConfigTable.vue?vue&type=style&index=0&id=6f3d8bd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d8bd6",
  null
  
)

export default component.exports